import _ from 'lodash';
import { CloseIcon } from 'components/icons/CloseIcon';
import { ModalContext } from 'context/ModalContext';
import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { v4 as uuid } from 'uuid';
import clsx from 'clsx';
import api from 'services/api';

interface ICollection {
  selectedChannel: any;
  onCancel: () => void;
  videoId: string;
  videoHashId: string;
}

const Collection = (props: ICollection) => {
  const { hideModal } = useContext(ModalContext);
  const [collectionName, setCollectionName] = useState('');

  const channelList = useSelector((state: RootState) => state.channels.channelList);
  const selectedChannel = channelList.find((channel: any) => channel.id === props.selectedChannel.id);
  const initialPlaylistStates = [...selectedChannel.playlists]
    .sort((a: { name: string }, b: { name: string }) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      }
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      }
      return 0;
    })
    .filter((playlist: any) => {
      if (props.selectedChannel.playlists.find((item: any) => item.id === playlist.id)) {
        return true;
      }
      return false;
    });
  const [playlistStates, handlePlaylistStates] = useState(initialPlaylistStates);
  const [selectedPlaylists, setSelectedPlaylists] = useState(initialPlaylistStates.map((item) => item.id));

  const closeSelectPlaylist = () => {
    hideModal();
  };

  const shareOrSave = async () => {
    await api
      .post(`api/videos/collection/`, {
        action: 'update',
        channel: selectedChannel.hash_id,
        selectedPlaylists
      })
      .then(() => {
        props.onCancel();
      });
  };

  useEffect(() => {
    handlePlaylistStates(
      [...selectedChannel.playlists]
        .sort((a: { name: string }, b: { name: string }) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1;
          }
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1;
          }
          return 0;
        })
        .filter((playlist: any) => {
          if (props.selectedChannel.playlists.find((item: any) => item.id === playlist.id)) {
            return true;
          }
          return false;
        })
    );
  }, [selectedChannel.playlists]);

  const handleCheckboxChange = (position: number, event: any) => {
    if (event.target.checked) {
      setSelectedPlaylists((prev) => [...prev, Number(event.target.value)]);
      handlePlaylistStates((prev) => [
        ...prev,
        [...selectedChannel.playlists].find((playlist) => playlist.id == event.target.value)
      ]);
    } else {
      setSelectedPlaylists((prev) => [...prev].filter((value) => value != event.target.value));
      handlePlaylistStates((prev) => [...prev].filter((value) => value.id != event.target.value));
    }
  };

  return (
    <div className="transparent font-lato">
      <div className="relative border bg-gray-bg-dark border-gray-300 rounded-lg bg-white pb-7 pt-9 w-screen md:w-[622px] md:max-h-[508px]">
        <div className="flex px-7">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">{selectedChannel.name}</span>
          <CloseIcon
            className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100"
            onClick={closeSelectPlaylist}
          />
        </div>
        <div className="px-7 border-b border-gray-popup">
          <p className="mt-4">Name</p>
          <textarea
            className="px-4 py-2 w-full mb-4 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6 mt-1"
            value={collectionName}
            onChange={(e) => setCollectionName(e.target.value)}
          />
        </div>
        <div className="px-7 border-b border-gray-popup py-1">
          <p>Playlist title</p>
        </div>
        <div className="overflow-auto max-h-48">
          {[...selectedChannel.playlists]
            .sort((a: { name: string }, b: { name: string }) => {
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
              return 0;
            })
            .map((playlist: any, index: number) => (
              <div
                className="flex items-center py-1 px-7 border-b border-gray-popup w-full hover:bg-[#efefef] cursor-pointer"
                key={uuid()}
              >
                <input
                  type="checkbox"
                  id={`playlist-checkbox-${index}`}
                  className="focus:ring-0"
                  value={playlist.id}
                  name={playlist.name}
                  checked={playlistStates.find((item) => item.id === playlist.id)}
                  onChange={(event) => handleCheckboxChange(index, event)}
                />
                <label
                  htmlFor={`playlist-checkbox-${index}`}
                  className="text-base text-[#212529] font-normal font-lato pl-2 w-full cursor-pointer"
                >
                  {playlist.name}
                </label>
              </div>
            ))}
        </div>
        <div className="flex mt-5 px-7">
          {selectedChannel.share ? (
            <div
              className={clsx('w-40 h-11 rounded-[10px] text-base font-bold flex items-center justify-center ml-auto', {
                'bg-green-600 text-white cursor-pointer': !_.isEqual(playlistStates, initialPlaylistStates),
                'bg-buttonDisabledBg text-buttonDsiabledTxt pointer-events-none': _.isEqual(
                  playlistStates,
                  initialPlaylistStates
                )
              })}
              onClick={shareOrSave}
            >
              Save
            </div>
          ) : (
            <div
              className="w-24 h-11 bg-green-600 rounded-[10px] cursor-pointer text-white text-base font-bold flex items-center justify-center ml-auto"
              onClick={shareOrSave}
            >
              Share
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Collection;
